import classnames from 'classnames'
import * as React from 'react'

export interface ProgressRingProps {
  className?: string
  percentRemaining: number
  progressColor: string
  ringColor: string
}

const styles = require('./styles.scss')

const ProgressRing: React.SFC<ProgressRingProps> = ({ className, percentRemaining, progressColor, ringColor }) => {
  const circumference = 100 * Math.PI

  return (
    <svg className={classnames(styles.progressRing, className)} width="100" height="100" viewBox="0 0 100 100">
      <circle stroke={ringColor} strokeWidth="16" fill="transparent" r="50" cx="50" cy="50" />
      <circle
        stroke={progressColor}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={percentRemaining * circumference}
        strokeWidth="16"
        fill="transparent"
        r="50"
        cx="50"
        cy="50"
      />
    </svg>
  )
}

export default ProgressRing
